import React, { useState } from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import InfographicItem from './InfographicItem';
import Modal from '../../../components/Modal';
import './style.scss';

const ParagraphInfographicWrapper = ({ entity }) => {
  const touchPoints = entity.getIn(['field_infographic_touchpoints']);
  const [displayModal, setDisplayModal] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalContent, setModalContent] = useState();
  const [modalImage, setModalImage] = useState();

  const toggleModal = (title, body, image) => {
    setModalTitle(title);
    setModalContent(body);
    setModalImage(image);
    setDisplayModal(!displayModal);
  };

  return (
    <Container className="ParagraphInfographic__container">
      <div className="row">
        <div className="ParagraphInfographic__wrapper">
          {
            touchPoints.map((touchPoint) => {
              const uuid = touchPoint.getIn(['entity', 'uuid', 0, 'value']);

              return (
                <InfographicItem
                  key={uuid}
                  item={touchPoint}
                  toggle={toggleModal}
                />
              );
            })
          }
        </div>
        {displayModal && (
          <Modal
            className="Modal"
            title={modalTitle}
            content={modalContent}
            image={modalImage}
            closeFunction={toggleModal}
          />
        )}
      </div>
    </Container>
  );
};

export default ParagraphInfographicWrapper;
